<template>
    <button 
        class="btn btn-link m-0 p-0 bg-white border-0" 
        type="button" 
        v-clipboard:copy="url"
        :aria-label="ariaLabelProp"
        ref="button"
        @click="UrlCopied()">
        <slot />
        <span class="copy-url-message"
            :class="{'visually-hidden-copy-url-message': updateCopiedMessage === ''}" role="alert">
            {{ updateCopiedMessage }}
        </span>
    </button>
</template>

<script>
    export default {
        data() {
            return {
                url: window.location.href,
                updateCopiedMessage: ''
            }
        },
        props: {
            ariaLabelProp: {
                type: String,
                default: 'Copy site URL to your clipboard.'
            }
        },
        methods: {
            UrlCopied() {
                this.updateCopiedMessage = 'URL copied!';

                setTimeout(() => {
                    this.updateCopiedMessage = '';
                }, 500);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-copy-url-to-clipboard.vue